import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'arrow-down-icon',
  templateUrl: './arrow-down-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ArrowDownIconComponent {}
